import React, { useState, useEffect } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Typography
} from '@mui/material'
import { AxiosWithAuth } from '../../Utilities/authenticationService'

const StoreRegistrationModal = ({ open, onClose, onSubmit, sourceStore }) => {
    const [companies, setCompanies] = useState([])
    const [selectedCompany, setSelectedCompany] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (open) {
            setLoading(true)
            AxiosWithAuth.get('/companies')
                .then((res) => {
                    setCompanies(res.data)
                    setLoading(false)
                })
                .catch(err => {
                    console.error(err)
                    setLoading(false)
                })
        }
    }, [open])

    const handleClose = () => {
        setSelectedCompany('')
        onClose()
    }

    const handleSubmit = () => {
        if (sourceStore && selectedCompany) {
            const company = companies.find(c => c.id === selectedCompany)
            onSubmit({
                store: sourceStore,
                company: company
            })
            handleClose()
        }
    }

    const isValid = sourceStore && selectedCompany

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', pb: 2 }}>
                <Typography variant="h6" component="span">
                    店舗コピー
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ pt: 3, pb: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
                    <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            コピー元店舗
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {sourceStore?.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {sourceStore?.seg_code}
                        </Typography>
                    </Box>

                    <FormControl fullWidth>
                        <InputLabel>コピー先会社</InputLabel>
                        <Select
                            value={selectedCompany}
                            onChange={(e) => setSelectedCompany(e.target.value)}
                            label="コピー先会社"
                            disabled={loading}
                        >
                            {companies.map(company => (
                                <MenuItem key={company.id} value={company.id}>
                                    {company.company_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
                <Button onClick={handleClose} color="inherit">
                    キャンセル
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!isValid}
                    sx={{ minWidth: 80 }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default StoreRegistrationModal

